export default __webpack_public_path__ + "static/media/pool-white1.9e5c45e9.png";